import ArrowLeft from './arrow-left.svg'
import ArrowRight from './arrow-right.svg'
import Brand from './brand.svg'
import Company from './company.svg'
import Leaf1 from './leaf-1.svg'
import Play from './play.svg'
import SocialFacebook from './social-facebook.svg'
import SocialInstagram from './social-instagram.svg'
import SocialWhatsapp from './social-whatsapp.svg'
import SocialYoutube from './social-youtube.svg'

const svg = {
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'brand': Brand,
  'company': Company,
  'leaf-1': Leaf1,
  'play': Play,
  'social-facebook': SocialFacebook,
  'social-instagram': SocialInstagram,
  'social-whatsapp': SocialWhatsapp,
  'social-youtube': SocialYoutube,
}

export type SvgName = keyof typeof svg

export { svg }